var _classCallCheck = require("D:\\TeamCity\\buildAgent2\\work\\c3de73507ebe2590\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("D:\\TeamCity\\buildAgent2\\work\\c3de73507ebe2590\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _possibleConstructorReturn = require("D:\\TeamCity\\buildAgent2\\work\\c3de73507ebe2590\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("D:\\TeamCity\\buildAgent2\\work\\c3de73507ebe2590\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _inherits = require("D:\\TeamCity\\buildAgent2\\work\\c3de73507ebe2590\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
var React = require('react');
var PropTypes = require('prop-types');
var NotificationItem = require('./NotificationItem');
var Constants = require('./constants');
var NotificationContainer = /*#__PURE__*/function (_React$Component) {
  "use strict";

  _inherits(NotificationContainer, _React$Component);
  function NotificationContainer(props) {
    var _this;
    _classCallCheck(this, NotificationContainer);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotificationContainer).call(this, props));
    // Fix position if width is overrided
    _this._style = props.getStyles.container(props.position);
    if (props.getStyles.overrideWidth && (props.position === Constants.positions.tc || props.position === Constants.positions.bc)) {
      _this._style.marginLeft = -(props.getStyles.overrideWidth / 2);
    }
    return _this;
  }
  _createClass(NotificationContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var notifications;
      if ([Constants.positions.bl, Constants.positions.br, Constants.positions.bc].indexOf(this.props.position) > -1) {
        this.props.notifications.reverse();
      }
      notifications = this.props.notifications.map(function (notification) {
        return React.createElement(NotificationItem, {
          ref: 'notification-' + notification.uid,
          key: notification.uid,
          notification: notification,
          getStyles: _this2.props.getStyles,
          onRemove: _this2.props.onRemove,
          noAnimation: _this2.props.noAnimation,
          allowHTML: _this2.props.allowHTML,
          children: _this2.props.children
        });
      });
      return React.createElement("div", {
        className: 'notifications-' + this.props.position,
        style: this._style
      }, notifications);
    }
  }]);
  return NotificationContainer;
}(React.Component);
NotificationContainer.propTypes = {
  position: PropTypes.string.isRequired,
  notifications: PropTypes.array.isRequired,
  getStyles: PropTypes.object,
  onRemove: PropTypes.func,
  noAnimation: PropTypes.bool,
  allowHTML: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
module.exports = NotificationContainer;